import { render, staticRenderFns } from "./UninstallHelp.vue?vue&type=template&id=9b60acf4&scoped=true&"
import script from "./UninstallHelp.vue?vue&type=script&lang=ts&"
export * from "./UninstallHelp.vue?vue&type=script&lang=ts&"
import style0 from "./UninstallHelp.vue?vue&type=style&index=0&id=9b60acf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b60acf4",
  null
  
)

export default component.exports